














































import Vue from 'vue'
import CoreBase from '@corets/base'
import {mapGetters, mapActions} from 'vuex'
import Base from '@custom/base'
import utils from '@corets/utils'
import NCommonTitle from '@corecp/NCommonTitle.vue'

export default Vue.extend({
    name: 'Setting',
    mixins: [CoreBase, Base],
    components: {
        NCommonTitle
    },
    data () {
        return {
            sourceData: [],
            targetData: []
        }
    },
    computed: {
        ...mapGetters([
            'menuObj',
            'comConfig'
        ])
    },
    created () {
        const self = this as any
        self.init()
    },
    watch: {
        'comConfig.buildSwitch': {
            deep: true,
            handler (val, oldval) {
                localStorage.setItem('nearAdminCacheConfig', JSON.stringify(val))
            }
        },
        'comConfig.buildSwitch.isI18n' () {
            // if isI18n change, refresh page
            window.location.reload()
        }
    },
    methods: {
        ...mapActions([
            'changeCacheEntry'
        ]),
        init () {
            const self = this as any
            self.sourceData = utils.getMenuRootCp(self.menuObj.menuList, true)
            if (self.comConfig.buildSwitch.isCache) {
                // get cache entry
                const cacheEntry = localStorage.getItem('nearAdminCustomerEntry')
                self.targetData = cacheEntry ? JSON.parse(cacheEntry) : []
            }
        },
        handlerChange(targetKeys: any) {
            const self = this as any
            self.targetData = targetKeys
            if (self.comConfig.buildSwitch.isCache) {
                localStorage.setItem('nearAdminCustomerEntry', JSON.stringify(targetKeys))
                const cacheEntry = utils.getMenuRootCp(self.menuObj.menuList, true, undefined, targetKeys)
                self.changeCacheEntry(cacheEntry)
            }
        }
    }
})
